import { render, staticRenderFns } from "./Asset-Preview.vue?vue&type=template&id=0dd391d1&lang=pug"
import script from "./Asset-Preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asset-Preview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports